import useFetch from '@hooks/useFetch';

const useGuidedSection = (batchGroupUID, classType) => {
  const key = `v1/batch/batch_group/${batchGroupUID}/guided_section_info/?class_type=${classType}`;
  const {
    data: lessonData,
    isValidating,
    ...rest
  } = useFetch(
    key,
    {},
    {
      refreshInterval: 10000
    }
  );
  return {
    key,
    isValidating,
    ...rest,
    lessonData
  };
};

export default useGuidedSection;
